import React from 'react'
import NavBar from '../layout/NavBar'
import Container from '@bootstrap-styled/v4/lib/Container'
import Footer from '../layout/Footer'
import styled from 'styled-components'
import axios from 'axios'
import { Article, ArticleHeading } from '../content'
import Link from 'next/link'
import A from '@bootstrap-styled/v4/lib/A'
import { startCase } from 'lodash'
import Head from 'next/head'
import { H1 } from '../Typography'
import P from '@bootstrap-styled/v4/lib/P'

const PageBody = styled('div')`
  padding-top: 109px;
`

function BlogIndex ({ articles, blogCategory }) {

  const { title, metaTitle, metaDescription } = React.useMemo(() => {
    const title = blogCategory ? (blogCategory === 'faq' ? 'FAQs' : startCase(blogCategory)) : 'Blog'
    const metaTitle = blogCategory ? `${title} | Local Physio Network` : 'Blog: Pain, Injury & Recover Guides. Helpful Tips and Resources'
    const metaDescription = blogCategory ? null : 'Suffering from pain or injury? Want to understand the problem more? We have an array of helpful articles in our blog to help guide you to recovery.'
    return { title, metaTitle, metaDescription }
  }, [blogCategory])

  return (
    <PageBody>
      <Head>
        <title>{ metaTitle }</title>
        { metaDescription && <meta name="description" content={metaDescription}/> }
      </Head>
      <NavBar fixed={'true'}>
        <div className={'mx-auto'}/>
      </NavBar>
      <Container>
        <H1>{ blogCategory ? title : 'The Local Physio Network Blog' }</H1>
        <P>Handy pain & injury info, easy-to-read guides, helpful tips and resources. Just what the Physio ordered.</P>
        {articles.map((a, i) => <Article key={`article-${i}`}>
          <ArticleHeading>
            <Link passHref href={`/${a.category}/[blogId]`} as={`/${a.category}/${a.id}`}>
              <A>{a.title}</A>
            </Link>
          </ArticleHeading>
        </Article>)}
      </Container>
      <Footer/>
    </PageBody>
  )
}

BlogIndex.getInitialProps = async function getInitialProps ({ asPath, res }) {
  let blogCategory = null
  if (asPath.endsWith('/')) asPath = asPath.substr(0, asPath.length - 1);
  if (!asPath.endsWith('/blog')) {
    const [,c] = asPath.split('/')
    blogCategory = c
  }

  let url = `${process.env.REACT_APP_API_URL}/blog`
  if (blogCategory) url += `/${blogCategory}`
  const articles = await axios.get(url, {
    params: {
      _fields: 'id,category,title,createdAt',
    }
  })
    .catch(e => {
      console.log(e)
      if (e.response && e.response.status === 404) return { data: null }
      else throw e
    })
    .then(r => r.data)

  if (res) {
    res.setHeader('Cache-Control', 'public, max-age=3600, stale-while-revalidate=86400')
  }

  return {
    articles,
    blogCategory,
  }
}

export default BlogIndex
